import { TextareaHTMLAttributes, forwardRef } from "react";
import { cn } from "@/lib/utils";

export interface BrutalTextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {}

const BrutalTextarea = forwardRef<HTMLTextAreaElement, BrutalTextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          "w-full border-[3px] border-dark p-3 font-body text-base bg-card text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-4 focus:ring-primary transition-all disabled:cursor-not-allowed disabled:opacity-50 resize-y min-h-[100px]",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);

BrutalTextarea.displayName = "BrutalTextarea";

export { BrutalTextarea };
